import defaultSettings from '@/settings'

const title = defaultSettings.title || 'Vue Admin Template'
console.log('defaultSettings: ', defaultSettings)

export default function getPageTitle(pageTitle) {
  if (pageTitle) {
    return `${pageTitle} - ${title}`
  }
  return `${title}`
}
